import React, { InputHTMLAttributes, ReactNode } from 'react';
import './modernInput.scss';

interface ModernInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  icon?: ReactNode;
  error?: string;
  fullWidth?: boolean;
}

const ModernInput = ({
  label,
  icon,
  error,
  fullWidth = true,
  className = '',
  ...inputProps
}: ModernInputProps) => {
  return (
    <div
      className={`modern-input-container ${fullWidth ? 'full-width' : ''} ${className}`}
    >
      {label && <label className="modern-input-label">{label}</label>}
      <div className="modern-input-field-wrapper">
        {icon && <div className="modern-input-icon">{icon}</div>}
        <input
          className={`modern-input-field ${icon ? 'with-icon' : ''} ${error ? 'error' : ''}`}
          {...inputProps}
        />
      </div>
      {error && <div className="modern-input-error">{error}</div>}
    </div>
  );
};

export default ModernInput;
